import React from "react";
import { LoadingSpinnerAnimation, SpinnerContainer} from "./LoadingSpinnerStyled.js";

interface Props {
  widthToUse?: string;
  heightToUse?: string;
  containerHeight?: string;
}

const  LoadingSpinner = ({ widthToUse, heightToUse, containerHeight }: Props, Ref: any) => {
  return (
    <SpinnerContainer style={{height: containerHeight || '350px'}}>
      <LoadingSpinnerAnimation style={{  width: widthToUse || '100px', height: heightToUse || '100px' }}/>
    </SpinnerContainer>
  );
};

export default LoadingSpinner
